import classNames from "classnames"
import React, {memo} from "react"
import RRM from "react-responsive-modal"
import {CloseIcon, ModalContainer, ModalProps} from "./Modal"
import styles from "./Modal.module.scss"

export const CenteredModal: React.FC<ModalProps & {smallestCloseIcon?: boolean}> = memo(
    ({
        open,
        onClose,
        disableFormElements,
        children,
        showCloseIcon,
        className,
        id,
        withoutHeader,
        overlayClassName,
        smallestCloseIcon,
        ...modalContainerSettings
    }) => {
        return (
            <RRM
                open={!!open}
                onClose={onClose}
                animationDuration={400}
                classNames={{
                    root: classNames(styles.root, withoutHeader && styles.withoutHeader),
                    modalContainer: styles.modalContainer,
                    overlay: classNames(
                        styles.overlay,
                        overlayClassName,
                        withoutHeader && styles.withoutHeader
                    ),
                    modal: classNames(
                        className,
                        styles.modal,
                        styles.centered,
                        styles.center,
                        styles.ownScroll,
                        {
                            [styles.open]: open,
                        }
                    ),
                }}
                blockScroll={false}
                closeOnOverlayClick={false}
                closeOnEsc={false}
                showCloseIcon={false}
            >
                <fieldset disabled={disableFormElements}>
                    <ModalContainer modalId={id} {...modalContainerSettings}>
                        {children}
                        <CloseIcon
                            className={classNames(
                                styles["modal-close-button"],
                                smallestCloseIcon && styles.closeButton_smallest
                            )}
                            onClick={onClose}
                            show={!!showCloseIcon}
                            smooth={false}
                            isSmallestIcon={smallestCloseIcon}
                        />
                    </ModalContainer>
                </fieldset>
            </RRM>
        )
    }
)
